import { render, staticRenderFns } from "./PhotoRow.vue?vue&type=template&id=670f3d1a&"
import script from "./PhotoRow.vue?vue&type=script&lang=ts&"
export * from "./PhotoRow.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoRow.vue?vue&type=style&index=0&id=670f3d1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports